module.exports = __webpack_public_path__ + "assets/events_toc_white.1ebe2460.svg";